'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ALIGN_MAP = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
};

var borderRadius = function borderRadius(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var borderRadius = theme.reactackle.components.tag.borderRadius;


  return (0, _styledComponents.css)(['border-radius:', ';'], (0, _reactackleCore.getValueString)(borderRadius));
};

var colorScheme = function colorScheme(_ref2) {
  var themeFromProvider = _ref2.theme,
      bgColorCustom = _ref2.bgColorCustom,
      textColorCustom = _ref2.textColorCustom;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com = theme.reactackle.components.tag,
      backgroundColor = _theme$reactackle$com.backgroundColor,
      textColor = _theme$reactackle$com.textColor;


  return (0, _styledComponents.css)(['background-color:', ';color:', ';'], bgColorCustom || backgroundColor, textColorCustom || textColor);
};

var fontStyle = function fontStyle(_ref3) {
  var themeFromProvider = _ref3.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com2 = theme.reactackle.components.tag,
      fontSize = _theme$reactackle$com2.fontSize,
      lineHeight = _theme$reactackle$com2.lineHeight;


  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';'], (0, _reactackleCore.getValueString)(fontSize), lineHeight);
};

var align = function align(_ref4) {
  var themeFromProvider = _ref4.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var alignY = theme.reactackle.components.tag.content.alignY;


  return (0, _styledComponents.css)(['align-items:', ';'], ALIGN_MAP[alignY]);
};

var TagStyled = exports.TagStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TagStyled'
})(['display:inline-flex;vertical-align:middle;user-select:none;max-width:100%;', ' ', ' ', ' ', ' ', ''], fontStyle, colorScheme, borderRadius, align, (0, _reactackleCore.transition)('background-color, color, opacity'));


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-tag/dist/styles/TagStyled.js
// module id = 832
// module chunks = 0